import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, IconButton, useMediaQuery } from '@mui/material';
import { IconMenu2 } from '@tabler/icons-react';

// project imports
import LogoSection from '../LogoSection';
import ProfileSection from './ProfileSection';
// assets

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = ({ handleLeftDrawerToggle }) => {
    const theme = useTheme();
    const matchDownMd = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <>
            {/* logo & toggler button */}
            <Box
                sx={{
                    width: 228,
                    display: 'flex',
                    [theme.breakpoints.down('md')]: {
                        width: 'auto'
                    }
                }}
            >
                <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    onClick={handleLeftDrawerToggle}
                    edge="start"
                    sx={{
                        mr: 2,
                        display: { xs: 'flex', md: 'none' }
                    }}
                >
                    <IconMenu2 />
                </IconButton>
                <Box component="span" sx={{ display: { xs: 'block', md: 'block' }, flexGrow: 1 }}>
                    <LogoSection />
                </Box>
            </Box>

            {/* header search */}
            <Box sx={{ flexGrow: 1 }} />
            <Box sx={{ flexGrow: 1 }} />

            {/* notification & profile */}
            <ProfileSection />
        </>
    );
};

Header.propTypes = {
    handleLeftDrawerToggle: PropTypes.func
};

export default Header;
